export default __webpack_public_path__ + "images/IX.9fe6158.png";